/**
 * Global debugging utility for beacon performance analysis
 * Can be controlled from browser console
 */

import {
  setDebugEnabled as setBeaconDebugEnabled,
  getDebugLogs,
  clearDebugLogs,
  generatePerformanceReport
} from 'utils/beaconDebug';
import {
  getPerformanceMetrics,
  logPerformanceMetrics,
  resetPerformanceMetrics
} from 'utils/beaconPerformance';
import { clearBeaconCache } from 'utils/beaconPositioning';

// Global debug object
const globalBeaconDebug = {
  // Enable/disable debugging
  enable: () => {
    setBeaconDebugEnabled(true);
    console.log('Beacon debugging enabled. Use window.beaconDebug.showLogs() to view logs.');
  },
  
  disable: () => {
    setBeaconDebugEnabled(false);
    console.log('Beacon debugging disabled.');
  },
  
  // Show debug logs
  showLogs: () => {
    const logs = getDebugLogs();
    console.log('Beacon Debug Logs:', logs);
    return logs;
  },
  
  // Clear debug logs
  clearLogs: () => {
    clearDebugLogs();
    console.log('Beacon debug logs cleared.');
  },
  
  // Show performance metrics
  showMetrics: () => {
    const metrics = getPerformanceMetrics();
    console.log('Beacon Performance Metrics:', metrics);
    return metrics;
  },
  
  // Log performance metrics to console
  logMetrics: () => {
    logPerformanceMetrics();
  },
  
  // Reset performance metrics
  resetMetrics: () => {
    resetPerformanceMetrics();
    console.log('Beacon performance metrics reset.');
  },
  
  // Clear element cache
  clearCache: () => {
    clearBeaconCache();
    console.log('Beacon element cache cleared.');
  },
  
  // Generate performance report
  report: () => {
    generatePerformanceReport();
  },
  
  // Force beacon repositioning
  reposition: () => {
    // This would need to be implemented in the component
    console.log('Manual repositioning would need to be triggered from component context.');
  }
};

// Expose globally
if (typeof window !== 'undefined') {
  window.beaconDebug = globalBeaconDebug;
}

export default globalBeaconDebug;